import { isMsiPage } from './pageType';
import { trackEvent as trackLegacyEvent } from './track';
import { trackEvent as trackCardMsiEvent } from './trackCardMsi';

const trackOnelinkEvent = (
    eventId: string,
    attrs?: Record<string, string | number | boolean>
) => {
    if (isMsiPage()) {
        return trackCardMsiEvent(eventId, attrs);
    }

    return trackLegacyEvent(eventId, attrs);
};

export const getOnelinkUrl = () => {
    try {
        const link = window.adv.getDeeplinkURLByBID('FINTECH_APP');

        if (link) {
            trackOnelinkEvent('fin_outcast_generate_onelink_url_success_st', {
                onelink_url: link
            });

            return link;

        } else {
            trackOnelinkEvent('fin_outcast_generate_onelink_url_fail_st', {
                error_msg: 'getDeeplinkURLByBID link is null'
            });
        }
    } catch (e: unknown) {
        const errorMessage = (e as Error)?.message; // Type assertion

        trackOnelinkEvent('fin_outcast_generate_onelink_url_fail_st', {
            error_msg: errorMessage
        });
    }
};
